import { createBrowserRouter } from "react-router-dom";
import ErrorPage from "../../error-page";
import Login from "./Auth/Login";
import RequireAuth from "./Auth/RequireAuth";
import Layout from "./Layout";
import { AuthProvider } from "./Auth/AuthContext";
import ErrorTest from "./ErrorTest";
import NotFound from "./NotFound";

const router = createBrowserRouter([
  {
    path: "/",
    element: <AuthProvider><Layout /></AuthProvider>,
    errorElement: <ErrorPage />,
    children: [
      {
        index: true,
        element: <Login />,
      },
      {
        path: "error-test",
        element: <ErrorTest />,
      },
      {
        // Route publique pour la signature bénéficiaire
        // Le token JWT dans l'URL permet l'accès sans authentification
        path: "signature",
        lazy: () => import("./Signature").then(m => ({ Component: m.default })),
      },
      {
        // Route publique pour l'enquête de satisfaction bénéficiaire
        // Le token UUID dans l'URL permet l'accès sans authentification
        path: "survey",
        lazy: () => import("./Survey").then(m => ({ Component: m.default })),
      },
      {
        // Route publique après signature bénéficiaire (retour YouSign)
        // Vérifie l'éligibilité au survey et redirige si applicable
        path: "signature-success",
        lazy: () => import("./SignatureSuccess").then(m => ({ Component: m.default })),
      },
      {
        // Route publique de rétractation bénéficiaire pour un contrat upsell
        // Accessible via le lien reçu dans l'email de confirmation du contrat
        path: "retractation/:leadId",
        lazy: () => import("./Retractation").then(m => ({ Component: m.default })),
      },
      {
        // Route publique statique "Comment déclarer une panne" — destination du
        // lien envoyé par email/SMS après la souscription (relances post-souscription)
        path: "comment-declarer-une-panne",
        lazy: () => import("./CommentDeclarerPanne").then(m => ({ Component: m.default })),
      },
      {
        element: <RequireAuth />,
        children: [
          {
            path: "dashboard",
            lazy: () => import("./Dashboard").then(m => ({ Component: m.default })),
          },
          {
            path: "declaration/new",
            lazy: () => import("./Declaration").then(m => ({ Component: m.Declaration })),
          },
          {
            path: "declaration/:id",
            lazy: () => import("./DeclarationRouter").then(m => ({ Component: m.default })),
          },
          {
            path: "declaration/v1/:id",
            lazy: () => import("./DeclarationDetailV1").then(m => ({ Component: m.default })),
          },
          {
            path: "declaration/:id/:interventionId",
            lazy: () => import("./DeclarationDetail").then(m => ({ Component: m.default })),
          },
          {
            path: "declaration/:id/:interventionId/confirmation",
            lazy: () => import("./DeclarationConfirmation").then(m => ({ Component: m.default })),
          },
        ],
      },
    ],
  },

  {
    path: '*',
    element: <NotFound />,
  }
]);

export default router;